import { render, staticRenderFns } from "./testPdf.vue?vue&type=template&id=5ec67050&"
import script from "./testPdf.vue?vue&type=script&lang=js&"
export * from "./testPdf.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports